import { useEffect, useState } from "react";
import { ResumoCotasUsuariosEmpreendimento } from "../interfaces/ResumoCotasUsuariosEmpreendimento";
import { buscarResumoCotasUsuariosEmpreendimentoService } from "../services/buscarResumoCotasUsuariosEmpreendimentoService";

export const useResumoCotasUsuariosEmpreendimentos = (
  empreendimentoIds: Array<number | null | undefined>
) => {
  const [isLoading, setIsLoading] = useState(false);
  const [resumosPorEmpreendimento, setResumosPorEmpreendimento] = useState<
    Record<number, ResumoCotasUsuariosEmpreendimento>
  >({});
  const idsKey = Array.from(
    new Set(
      empreendimentoIds.filter(
        (id): id is number => typeof id === "number" && Number.isFinite(id)
      )
    )
  )
    .sort((a, b) => a - b)
    .join(",");

  useEffect(() => {
    const ids = idsKey
      .split(",")
      .filter(Boolean)
      .map((id) => Number(id));

    if (ids.length === 0) {
      setResumosPorEmpreendimento({});
      setIsLoading(false);
      return;
    }

    let isMounted = true;

    const buscarResumos = async () => {
      setIsLoading(true);

      try {
        const resultados = await Promise.all(
          ids.map(async (id) => ({
            id,
            resumo:
              await buscarResumoCotasUsuariosEmpreendimentoService(id),
          }))
        );

        if (!isMounted) {
          return;
        }

        const proximosResumos = resultados.reduce<
          Record<number, ResumoCotasUsuariosEmpreendimento>
        >((acc, { id, resumo }) => {
          if (resumo) {
            acc[id] = resumo;
          }

          return acc;
        }, {});

        setResumosPorEmpreendimento(proximosResumos);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    buscarResumos();

    return () => {
      isMounted = false;
    };
  }, [idsKey]);

  return { resumosPorEmpreendimento, isLoading };
};
